import { makeStyles, styled } from "@material-ui/styles";
import { CollapsableSection, Column } from "lqx-react";
import React from "react";
import {
    FormLabel,
    Input,
} from "lqx-react/lib";
import { ErrorHighligter, asTimelessLinkedDate, DigiDateInput } from "../shared";
import { AssetColumn, numberInputStyles } from "../components/number-input";
import { DigiSelectAsync } from "../components/select-async";
import { getSuppliersAsCommonParticipants, getBuyersAsCommonParticipants } from "../api/companyParticipant";
import NumberFormat from "react-number-format";
import { getCompaniesAsCommonParticipants } from "../api/company";
import { Invoice } from "../api/invoice";
import { globalStore } from 'api/store';
import { DigiCurrencySelect } from "../components/select";

export const EditInvoiceTab = ({ invoice, errors }: { invoice: Invoice, errors }) => {
    const sectionStyles = SectionStyles();
    const classesNum = numberInputStyles();

    return (<>
        <CollapsableSection title="General" titleClassName={sectionStyles.sectionTitle} noBorder noShadow>
            <Column>
                <FlexStyled>
                    <StyledFormLabel>Invoice Number</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.Number']}>
                        <StyledInput data-qa-id="invoice number" type={'string'} $value={invoice.$.number} />
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Buyer Name</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.Buyer']}>
                        <DigiSelectAsync
                            data-qa-id={"buyer"}
                            getItems={getBuyersAsCommonParticipants}
                            $value={invoice.$.buyer}
                            styles={{ minWidth: '350px' }}
                        />
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Supplier Name</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.Supplier']}>
                        <DigiSelectAsync
                            data-qa-id={"supplier"}
                            getItems={getSuppliersAsCommonParticipants}
                            $value={invoice.$.supplier}
                            styles={{ minWidth: '350px' }}
                        />
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Face Value</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.FaceValue']}>
                        <InputWrraper>
                            <NumberFormatStyled
                                data-qa-id="face value"
                                value={invoice.$.faceValue.value}
                                className={classesNum.numericInput}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                thousandSeparator={true}
                                onValueChange={(values) => { const { floatValue } = values; invoice.$.faceValue.set(floatValue) }}
                            />
                        </InputWrraper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Currency</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.Currency']}>
                        <InputWrraper>
                            <DigiCurrencySelect
                                isMulti={false}
                                options={globalStore.currenciesLookup.items.models}
                                $value={invoice.$.currency}
                            />
                        </InputWrraper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Invoice Date</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.InvoiceDate']}>
                        <DigiDateWrapper>
                            <DigiDateInputStyled data-qa-id="invoice date" date $value={asTimelessLinkedDate(invoice.$.invoiceDate)} />
                        </DigiDateWrapper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Invoice Due Date</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.InvoiceDueDate']}>
                        <DigiDateWrapper>
                            <DigiDateInputStyled data-qa-id="invoice due date" date $value={asTimelessLinkedDate(invoice.$.invoiceDueDate)} />
                        </DigiDateWrapper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Effective Date</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.EffectiveDate']}>
                        <DigiDateWrapper>
                            <DigiDateInputStyled data-qa-id="Effective date" date $value={asTimelessLinkedDate(invoice.$.effectiveDate)} />
                        </DigiDateWrapper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Funding Date</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.FundingDate']}>
                        <DigiDateWrapper>
                            <DigiDateInputStyled data-qa-id="funding date" date $value={asTimelessLinkedDate(invoice.$.fundingDate)} />
                        </DigiDateWrapper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Anticipated Settlement Date</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.AnticipatedSettlementDate']}>
                        <DigiDateWrapper>
                            <DigiDateInputStyled data-qa-id="anticipated settlement date" date $value={asTimelessLinkedDate(invoice.$.anticipatedSettlementDate)} />
                        </DigiDateWrapper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Anticipated Payment Date</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.AnticipatedPaymentDate']}>
                        <DigiDateWrapper>
                            <DigiDateInputStyled data-qa-id="anticipated payment date" date $value={asTimelessLinkedDate(invoice.$.anticipatedPaymentDate)} />
                        </DigiDateWrapper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Promise To Pay Date</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.PromisePayDate']}>
                        <DigiDateWrapper>
                            <DigiDateInputStyled data-qa-id="promise to pay date" date $value={asTimelessLinkedDate(invoice.$.promisePayDate)} />
                        </DigiDateWrapper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Adjustment Amount</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.AdjustmentAmount']}>
                        <InputWrraper>
                            <NumberFormatStyled value={invoice.$.adjustmentAmount.value} className={classesNum.numericInput} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} onValueChange={(values) => { const { floatValue } = values; invoice.$.adjustmentAmount.set(floatValue) }} />
                        </InputWrraper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Outstanding Amount Seller</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.OutstandingAmountSeller']}>
                        <InputWrraper>
                            <NumberFormatStyled value={invoice.$.outstandingAmountSeller.value} className={classesNum.numericInput} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} onValueChange={(values) => { const { floatValue } = values; invoice.$.outstandingAmountSeller.set(floatValue) }} />
                        </InputWrraper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Adjusted Face Value</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.AdjustedFaceValue']}>
                        <InputWrraper>
                            <Input data-qa-id="adjustment face value" number $value={invoice.$.adjustedFaceValue} />
                        </InputWrraper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Payment Terms</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.PaymentTerms']}>
                        <InputWrraper>
                            <Input data-qa-id="payment terms" number $value={invoice.$.paymentTerms} />
                        </InputWrraper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Purchase Order Number</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.PurchaseOrder.Number']}>
                        <InputWrraper>
                            <Input $value={invoice.purchaseOrder.$.number} />
                        </InputWrraper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Alternate ID</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.AlternateId']}>
                            <StyledInput data-qa-id="alternate id" type={'string'} $value={invoice.$.alternateId} />
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Notification Number</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.NotificationNumber']}>
                            <StyledInput data-qa-id="notification number" type={'string'} $value={invoice.$.notificationNumber} />
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Ref 1</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.Ref1']}>
                            <StyledInput data-qa-id="ref 1" type={'string'} $value={invoice.$.ref1} />
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Ref 2</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.Ref2']}>
                            <StyledInput data-qa-id="ref 2" type={'string'} $value={invoice.$.ref2} />
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Ref 3</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.Ref3']}>
                            <StyledInput data-qa-id="ref 3" type={'string'} $value={invoice.$.ref3} />
                    </ErrorHighligterStyled>
                </FlexStyled>
            </Column>
        </CollapsableSection>
        <CollapsableSection title="Monetization Fields" titleClassName={sectionStyles.sectionTitle} noBorder noShadow>
            <Column>
                <FlexStyled>
                    <StyledFormLabel>Funder Name</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.ProposedMonetization.Funder']}>
                        <FunderWrraper>
                            <DigiSelectAsync
                                data-qa-id={"funder"}
                                getItems={getCompaniesAsCommonParticipants}
                                $value={invoice.proposedMonetization.$.funder}
                                styles={{ height: '34px' }}
                            />
                        </FunderWrraper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Net Face Value</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.ProposedMonetization.NetFaceValue']}>
                        <InputWrraper>
                            <NumberFormatStyled data-qa-id="netFaceValue" value={invoice.proposedMonetization.netFaceValue} className={classesNum.numericInput} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} onValueChange={(values) => { const { floatValue } = values; invoice.proposedMonetization.$.netFaceValue.set(floatValue) }} />
                        </InputWrraper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Tenor</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.ProposedMonetization.Tenor']}>
                        <InputWrraper>
                            <Input data-qa-id="tenor" number $value={invoice.proposedMonetization.$.tenor} />
                        </InputWrraper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Base Rate</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.ProposedMonetization.BaseRate']}>
                        <InputWrraper>
                            <NumberFormatStyled data-qa-id="baseRate" value={invoice.proposedMonetization.baseRate} className={classesNum.numericInput} decimalScale={10} fixedDecimalScale={true} thousandSeparator={true} onValueChange={(values) => { const { floatValue } = values; invoice.proposedMonetization.$.baseRate.set(floatValue) }} />
                        </InputWrraper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Base Rate (%)</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.ProposedMonetization.BaseRatePercentage']}>
                        <InputWrraper>
                            <NumberFormatStyled data-qa-id="baseRatePercentage" suffix='%' value={invoice.proposedMonetization.baseRatePercentage} className={classesNum.numericInput} decimalScale={10} allowNegative={false} fixedDecimalScale={true} thousandSeparator={true} onValueChange={(values) => { const { floatValue } = values; invoice.proposedMonetization.$.baseRatePercentage.set(floatValue) }} />
                        </InputWrraper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Base Rate Amount</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.ProposedMonetization.BaseRate']}>
                        <InputWrraper>
                            <NumberFormatStyled data-qa-id="baseRateAmount" value={invoice.proposedMonetization.baseRateAmount} className={classesNum.numericInput} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} onValueChange={(values) => { const { floatValue } = values; invoice.proposedMonetization.$.baseRateAmount.set(floatValue) }} />
                        </InputWrraper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Margin Rate</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.ProposedMonetization.MarginRate']}>
                        <InputWrraper>
                            <NumberFormatStyled data-qa-id="marginRate" value={invoice.proposedMonetization.marginRate} className={classesNum.numericInput} decimalScale={10} fixedDecimalScale={true} thousandSeparator={true} onValueChange={(values) => { const { floatValue } = values; invoice.proposedMonetization.$.marginRate.set(floatValue) }} />
                        </InputWrraper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Margin Rate (%)</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.ProposedMonetization.MarginRatePercentage']}>
                        <InputWrraper>
                            <NumberFormatStyled data-qa-id="marginRatePercentage" suffix='%' value={invoice.proposedMonetization.marginRatePercentage} className={classesNum.numericInput} decimalScale={10} allowNegative={false} fixedDecimalScale={true} thousandSeparator={true} onValueChange={(values) => { const { floatValue } = values; invoice.proposedMonetization.$.marginRatePercentage.set(floatValue) }} />
                        </InputWrraper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Margin Rate Amount</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.ProposedMonetization.MarginRateAmount']}>
                        <InputWrraper>
                            <NumberFormatStyled data-qa-id="marginRateAmount" value={invoice.proposedMonetization.marginRateAmount} className={classesNum.numericInput} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} onValueChange={(values) => { const { floatValue } = values; invoice.proposedMonetization.$.marginRateAmount.set(floatValue) }} />
                        </InputWrraper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Total Rate (Decimal)</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.ProposedMonetization.TotalRate']}>
                        <InputWrraper>
                            <NumberFormatStyled data-qa-id="totalRate" value={invoice.proposedMonetization.totalRate} className={classesNum.numericInput} decimalScale={10} fixedDecimalScale={true} thousandSeparator={true} onValueChange={(values) => { const { floatValue } = values; invoice.proposedMonetization.$.totalRate.set(floatValue) }} />
                        </InputWrraper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Total Rate (%)</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.ProposedMonetization.TotalRatePercentage']}>
                        <InputWrraper>
                            <NumberFormatStyled data-qa-id="totalRatePercentage" suffix='%' value={invoice.proposedMonetization.totalRatePercentage} className={classesNum.numericInput} decimalScale={10} allowNegative={false} fixedDecimalScale={true} thousandSeparator={true} onValueChange={(values) => { const { floatValue } = values; invoice.proposedMonetization.$.totalRatePercentage.set(floatValue) }} />
                        </InputWrraper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Total Rate Amount</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.ProposedMonetization.TotalRateAmount']}>
                        <InputWrraper>
                            <NumberFormatStyled data-qa-id="totalRateAmount" value={invoice.proposedMonetization.totalRateAmount} className={classesNum.numericInput} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} onValueChange={(values) => { const { floatValue } = values; invoice.proposedMonetization.$.totalRateAmount.set(floatValue) }} />
                        </InputWrraper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Purchase Price</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.ProposedMonetization.PurchasePrice']}>
                        <InputWrraper>
                            <NumberFormatStyled data-qa-id="purchasePrice" value={invoice.proposedMonetization.purchasePrice} className={classesNum.numericInput} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} onValueChange={(values) => { const { floatValue } = values; invoice.proposedMonetization.$.purchasePrice.set(floatValue) }} />
                        </InputWrraper>
                    </ErrorHighligterStyled>
                </FlexStyled>
            </Column>
        </CollapsableSection>
    </>)
}

const SectionStyles = makeStyles({
    sectionTitle: {
        color: '#63a9dc',
        fontSize: '13px',
        display: 'flex',
        alignItems: 'center'
    }
})

const ErrorHighligterStyled = styled(ErrorHighligter)({
    minWidth: '350px !important',
})

const NumberFormatStyled = styled(NumberFormat)({
    width: '350px !important',
})

const InputWrraper = styled('div')({
    width: '100%',
    height: '34px',
    maxWidth: '350px',
    '& input': {
        height: '34px'
    }
})

const FunderWrraper = styled('div')({
    width: '100%',
    maxWidth: '350px',
})

const FlexStyled = styled(AssetColumn)({
    width: '100%',
    height: '34px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: '8px',
    marginLeft: 0,
    marginRight: 0,
})

const StyledFormLabel = styled(FormLabel)({
    color: '#767D84',
    display: 'flex',
    fontSize: '12px',
    fontFamily: 'Montserrat',
    fontWeight: 500,
    maxWidth: '300px'
})

const StyledInput = styled(Input)({
    marginTop: 4,
    marginBottom: 4,
    height: 32,
    width: '350px'
})

const DigiDateWrapper = styled('div')({
    '& .react-datepicker-wrapper': {
        width: '350px',
        height: '34px',
    },
    '& input': {
        maxWidth: '350px',
        height: '34px',
    }
})

const DigiDateInputStyled = styled(DigiDateInput)({
    width: '350px',
})
